/* ==========================================================================
   AUMI — cart-page.js
   A quantidade, o remover e a nota já são tratados pelo global.js
   ([data-cart-qty-change], [data-cart-remove], [data-cart-qty-input], [data-cart-note]).
   Aqui a página de carrinho:
     1. entra em AUMI.cart.sections, para que add/change devolvam o HTML desta
        seção junto da resposta ([data-cart-render="main-cart"]);
     2. ouve aumi:cart-updated e, quando a mudança veio de refresh/update
        (sem HTML embutido), re-renderiza via ?section_id=<id>;
     3. copia o cupom de primeira compra.
   ========================================================================== */
(() => {
  if (customElements.get('cart-page')) return;

  class CartPage extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      const aumi = (window.AUMI = window.AUMI || {});
      aumi.cart = aumi.cart || {};
      aumi.cart.sections = aumi.cart.sections || ['cart-drawer'];
      if (!aumi.cart.sections.includes(this.sectionId)) aumi.cart.sections.push(this.sectionId);

      this.onUpdated = (event) => {
        const source = event.detail && event.detail.source;
        if (source === 'refresh' || source === 'update') this.render();
      };
      this.onError = () => this.render();
      document.addEventListener('aumi:cart-updated', this.onUpdated);
      document.addEventListener('aumi:cart-error', this.onError);

      this.addEventListener('click', (event) => {
        const copy = event.target.closest('[data-copy-coupon]');
        if (!copy) return;
        const label = copy.textContent;
        navigator.clipboard
          .writeText(copy.dataset.copyCoupon)
          .then(() => {
            copy.textContent = 'Copiado';
            if (typeof aumi.toast === 'function') aumi.toast('Cupom copiado. Cole no pagamento.');
            setTimeout(() => {
              copy.textContent = label;
            }, 2400);
          })
          .catch(() => {});
      });
    }

    disconnectedCallback() {
      document.removeEventListener('aumi:cart-updated', this.onUpdated);
      document.removeEventListener('aumi:cart-error', this.onError);
      const sections = window.AUMI && window.AUMI.cart && window.AUMI.cart.sections;
      if (sections) {
        const i = sections.indexOf(this.sectionId);
        if (i > -1) sections.splice(i, 1);
      }
    }

    async render() {
      if (this.rendering) {
        this.pending = true;
        return;
      }
      this.rendering = true;
      try {
        const base = (window.AUMI && window.AUMI.routes && window.AUMI.routes.cart) || '/cart';
        const html = await fetch(`${base}?section_id=${encodeURIComponent(this.sectionId)}`).then((r) => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-cart-render="main-cart"]');
        const current = this.querySelector('[data-cart-render="main-cart"]');
        if (fresh && current) {
          const focusKey = document.activeElement && document.activeElement.dataset ? document.activeElement.dataset.focusKey : null;
          current.innerHTML = fresh.innerHTML;
          if (focusKey) current.querySelector(`[data-focus-key="${focusKey}"]`)?.focus({ preventScroll: true });
        }
      } catch (error) {
        /* mantém o HTML atual */
      } finally {
        this.rendering = false;
        if (this.pending) {
          this.pending = false;
          this.render();
        }
      }
    }
  }

  customElements.define('cart-page', CartPage);
})();
